/**
 * Проверяет наличие собственного свойства в объекте, исключая свойства из прототипа.
 *
 * @param obj Объект, в котором ищем свойство.
 * @param key Название свойства, которое проверяем.
 * @returns Истина, если свойство есть
 * @example
 * ```ts
 * const obj = { name: 'John', age: 30 };
 *
 * console.log(hasOwnProperty(obj, 'name')); // true
 * console.log(hasOwnProperty(obj, 'age'));  // true
 * console.log(hasOwnProperty(obj, 'city')); // false
 *
 * // Отличие от оператора in: не проверяет свойства прототипа
 * console.log('toString' in obj);           // true
 * console.log(hasOwnProperty(obj, 'toString')); // false
 * ```
 */
export function hasOwnProperty(obj, key) {
    return obj.hasOwnProperty(key);
}
